import AutoBind from 'auto-bind';
// import Prefix from 'prefix';
// Make sure this extends Component again
import Component from '../classes/Component';

export default class Animation extends Component { // <-- Add 'extends Component'
  constructor({ element, elements }) {
    super({ element, elements }); // <-- Add super()
    AutoBind(this);

    const { animationDelay, animationTarget } = element.dataset;

    this.delay = animationDelay;
    this.element = element;
    this.elements = elements;

    this.target = animationTarget ? element.closest(animationTarget) : element;

    // New flag to track if the animation has already played on this page
    this.hasAnimated = false;

    this.isVisible = false;

    this.createObserver();
  }

  createObserver() {
    const options = {
      rootMargin: '0px',
      threshold: 0,
    }

    // 1. Check for a valid target
    if (!this.target) {
      console.error('Animation target not found for element:', this.element);
      return;
    }

    this.observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        // CRITICAL FIX: Only call animateIn if it hasn't run yet
        if (entry.isIntersecting && !this.hasAnimated) {
          this.animateIn();

          // Immediately stop observing once the animation has been triggered
          this.observer.unobserve(this.target);

        } else if (!entry.isIntersecting) {
          // Note: animateOut will still run if you scroll away before the animation is complete.
          // But since we unobserve above, this is only relevant for non-one-time animations.
          this.animateOut();
        }
      });
    }, options);


    this.observer.observe(this.target);
  }

  animateIn() {
    this.isVisible = true;
    this.hasAnimated = true; // Set flag when animation begins
  }

  animateOut() {
    this.isVisible = false;
  }
}